<template>
    <div class="specials-list-section">
        <!-- 13专题 -->
        <van-row
            class="specials-list-section-box"
            @click="goDetail(dataItem)"
        >
            <div class="specials-list-section-left">
                <van-image
                    fit="cover"
                    class="specials-list-section-left-img"
                    :src="dataItem.content.cover_img"
                    width="100%"
                    height="100%"
                />
                <div class="specials-list-section-left-top" v-if="dataItem.top == 1">
                    <img src="/static/v4/tag_top.svg" alt="" />
                </div>
                <div class="specials-list-section-left-zl" v-else>
<!--                    {{ dataItem.type_text }}-->
                  <img src="/static/v4/icon_list_tag_column.svg" alt="" />
                </div>
            </div>
            <div class="specials-list-section-right">
                <div class="specials-list-section-right-title" v-html="dataItem.content.title">
                </div>
                <div class="specials-list-section-right-detail">
                    <div>
                        <!-- {{ dataItem.content.created_at }}-->
                        <span>{{ dataItem.content.view_count }}人阅读</span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </van-row>
    </div>
</template>

<script>
import mixins from './mixin'
import Interface from '@/util/interface'
export default {
    mixins: [mixins],
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },
    methods: {
      goDetail(dataItem) {
        this.$router.push({ name: 'topic-detail', params: { id: dataItem.content.id } })
        Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
        Interface.getData('get', `/course/api/content_relation/${dataItem.id}/view`)
      }
    }
}
</script>

<style lang="scss" scoped>
@import "./special.scss";
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/special.vue